
function setSubmitValidity(contactForm) {
	const isValid = contactForm.checkValidity();
	const submit = contactForm.querySelector('.pbsm-contact-form__submit');
	if (submit) {
		if (! isValid) {
			submit.setAttribute('disabled', true);
			submit.setAttribute('aria-disabled', true);
		} else {
			submit.removeAttribute('disabled');
			submit.removeAttribute('aria-disabled');
		}
	}
}

export function initContactValidation(contactForm) {
	const fields = contactForm.querySelectorAll('input, textarea');
	if (fields && (fields.length > 0)) {
		fields.forEach( function(field, i) {
			field.addEventListener('keyup', function(e) {
				setSubmitValidity(contactForm);
			});
			field.addEventListener('click', function(e) {
				setSubmitValidity(contactForm);
			});
		});
	}
	setTimeout(function() {
		setSubmitValidity(contactForm);
	}, 250);
}

export function initContactValidations() {
	const contactForms = document.querySelectorAll('.pbsm-contact-form__form');
	if (contactForms && (contactForms.length > 0)) {
		contactForms.forEach((contactForm, i) => {
			initContactValidation(contactForm);
		});
	}
}